<template>
  <div>
    <!-- :saving="saving" :loading="loading.checking_client" -->
    <create-card route_back="DriversList" model_name="motorista 3º ou transportadoras" >
      <template slot="form">

        <!-- v-model="valid"  -->
          <v-form lazy-validation v-model="valid">
            <v-stepper v-model="stepper" vertical class="ml-1 mr-1 elevation-0 d-flex flex-column">
              
              <v-stepper-step step="1"> Idenficação <small>Nome e documentos</small></v-stepper-step>
              <v-stepper-content step="1" >
                  <v-card color="white lighten-1" class="ma-3">
                    <v-card-text>
                      <v-form lazy-validation ref="step1">
                        <SelectModality :object_with_model="driver" multiple model="modality_ids" custom_label="Selecione os módulos disponiveis para o motorista"/>
                        <v-radio-group  row v-model="driver.kind">
                          <v-radio label="Motorista" :value="'driver'"></v-radio>
                          <v-radio label="Transportadora" :value="'transporter'"></v-radio>
                        </v-radio-group>
                        <v-text-field v-model="driver.name" label="Nome" prepend-icon="mdi-account" :rules="required"></v-text-field>
                        <div v-if="driver.kind == 'driver'">
                          <v-text-field v-model="driver.cpf" :loading="checking_document" :disabled="checking_document" @input="checkIfCpfExists(driver.cpf)" label="CPF" prepend-icon="mdi-smart-card-outline" v-mask="'###.###.###-##'" :rules="[...cpf, validarCPF]"></v-text-field>
                          <v-text-field v-model="driver.cnh" label="CNH" prepend-icon="mdi-smart-card-outline" :rules="cnh_rules" v-mask="'###########'"></v-text-field>
                        </div>
                        <div v-if="driver.kind =='transporter'">
                          <v-text-field v-model="driver.cnpj" :loading="checking_document" :disabled="checking_document" @input="checkIfCnpjExists(driver.cnpj)" label="CNPJ" prepend-icon="mdi-smart-card-outline" v-mask="'##.###.###/####-##'" :rules="[...cnpj]"></v-text-field>
                        </div>
                        <FileAttachment ref="attach" is_creating :update_infos="{API: 'Driver', MODEL:'Driver', id: ''}"></FileAttachment>
                      </v-form>
                    </v-card-text>
                  </v-card>
                  <v-btn text @click="() => { stepper = 1; }" disabled><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
                  <v-btn text @click="nextStep('step1')"><v-icon class="rodar-dow" large color="green darken-2">mdi-arrow-down</v-icon></v-btn>
              </v-stepper-content>
    
              <v-stepper-step step="2">Contatos</v-stepper-step>
              <v-stepper-content step="2">
                <v-card color="white lighten-1" class="ma-3">
                  <v-card-text>
                    <v-form lazy-validation ref="step2">
                      <v-text-field v-model="driver.contatos.emailPrimary" label="Email Principal" prepend-icon="mdi-email"></v-text-field>
                      <v-text-field v-model="driver.contatos.mobilePrimary" v-mask="'(##) #####-####'" type="tel" label="Celular Principal" prepend-icon="mdi-cellphone" :rules="required"></v-text-field>
                      <v-text-field v-model="driver.contatos.phonePrimary" v-mask="'(##) ####-####'" label="Fixo Principal" prepend-icon="mdi-phone"></v-text-field>
                      <v-text-field v-model="driver.contatos.emailSecondary" v-if="contato3 > 1" label="Email Secundário" prepend-icon="mdi-email"></v-text-field>
                      <v-text-field v-model="driver.contatos.phoneSecondary" v-if="contato3 > 1" v-mask="'(##) ####-####'" label="Fixo Secundário" prepend-icon="mdi-phone"></v-text-field>
                      <v-text-field v-model="driver.contatos.mobileSecondary" v-if="contato3 > 1" v-mask="'(##) #####-####'" label="Celular Secundário" prepend-icon="mdi-cellphone"></v-text-field>
                      <v-icon large @click="addContato('less')" v-if="contato3 > 1" color="error" class="mr-3">fa-minus</v-icon>
                      <v-icon large @click="addContato('more')" v-if="contato3 < 2" color="light-blue" class="ml-3">fa-plus</v-icon>
                    </v-form>
                  </v-card-text>
                </v-card>
                <v-btn text @click="stepper = 1"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
                <v-btn text @click="nextStep('step2')"><v-icon class="rodar-dow" large color="green darken-2">mdi-arrow-down</v-icon></v-btn>
              </v-stepper-content>
    
              <v-stepper-step step="3">Endereço <small>Digite o CEP para prenchimento automático</small> </v-stepper-step>
              <v-stepper-content step="3">
                <v-card color="white lighten-1" class="ma-3">
                  <v-card-text>
                    <v-form lazy-validation ref="step3">
                      <v-text-field label="CEP" prepend-icon="mdi-map" class="inputCEP" type="tel" v-mask="'#####-###'" :rules="required" @keyup="buscarCEP()" v-model="driver.address.cep"></v-text-field>
                      <v-text-field label="Rua / Avenida" prepend-icon="mdi-map-marker" class="rua" :rules="required" v-model="driver.address.logradouro"></v-text-field>
                      <v-text-field label="Número" prepend-icon="mdi-numeric" :rules="required" v-model="driver.addressNumber"></v-text-field>
                      <v-text-field label="Complemento" prepend-icon="mdi-information-box" v-model="driver.address.complemento"></v-text-field>
                      <v-text-field label="Bairro" prepend-icon="mdi-home-group" class="bairro" :rules="required" v-model="driver.address.bairro"></v-text-field>
                      <v-text-field label="Cidade" prepend-icon="mdi-city" class="cidade" :rules="required" v-model="driver.address.localidade"></v-text-field>
                      <v-text-field label="Estado (UF)" v-mask="'AA'" prepend-icon="mdi-pin" class="estado" :rules="required" v-model="driver.address.uf"></v-text-field>
                      <AddressProofFiles
                        ref="addressProof"
                        is_creating
                        :file_slots="2"
                      ></AddressProofFiles>
                    </v-form>
                  </v-card-text>
                </v-card>
                <v-btn text @click="stepper = 2"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
                <v-btn text @click="nextStep('step3')"><v-icon class="rodar-dow" large color="green darken-2">mdi-arrow-down</v-icon></v-btn>
              </v-stepper-content>
    
              <v-stepper-step step="4">Forma de recebimento</v-stepper-step>
              <v-stepper-content step="4">
                <v-card color="white lighten-1" class="ma-3">
                  <v-card-text>
                    <receipt-config-form ref="step4" :creating="true" :model="driver"></receipt-config-form>
                  </v-card-text>
                </v-card>
                <v-btn text @click="stepper = 3"><v-icon class="rodar-upp" large color="red darken-2">mdi-arrow-up</v-icon></v-btn>
                <v-btn color="success" @click="submitDriver()" :loading="saving">Salvar</v-btn>
              </v-stepper-content>

            </v-stepper>
          </v-form>
      </template>
    </create-card>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapState } from 'vuex';
import Api from '@/api/index';
import validations from '@/mixins/validations'

export default {
  name: 'NewDriver',
  mixins: [ validations ],

  components:{
    FileAttachment: () => import("@/components/shared/FileAttachment.vue"),
    AddressProofFiles: () => import("@/_backoffice/_registrations/components/drivers/AddressProofFiles.vue"),
    CreateCard: () => import("@/_backoffice/_registrations/components/shared/create/CreateCard.vue"),
    SelectModality: () => import("@/components/shared/SelectModality.vue"),
    ReceiptConfigForm: () => import("@/_backoffice/_registrations/components/shared/forms/ReceiptConfigForm.vue"),
  },
  data() {
    return {
      valid: true,
      stepper: 1,
      contato3: 1,
      saving: false,
      noAccount: false,
      cnpj_account: false,
      driver: {
        kind:'driver',
        used_in_wholesale: false,
        modality_ids: [],
        freight_kind_default: null,
        receipt_config: {
          kind: 'cash',
          kinds: ['cash'],
          pix_key_kind: null,
          pix_key: null,
        },
        name: '',
        cpf: '',
        cnpj: '',
        cnh: '',
        external: true,
        vrt_account_attributes: {
          totalBalance: 0,
          currentBalance: 0,
          futureBalance: 0,
          delayedBalance: 0,
          status_id: 1,
          comment: 'Conta criada'
        },
        contacts_attributes: [],
        accounts_attributes: [],
        address_attributes: {},
        contatos: {
          emailPrimary: '',
          phonePrimary: '',
          mobilePrimary: '',
          emailSecondary: '',
          phoneSecondary: '',
          mobileSecondary: '',
        },
        addressNumber: '',
        address: {
          cep: '',
          logradouro: '',
          complemento: '',
          bairro: '',
          localidade: '',
          uf: '',
        },
        accounts: {
          bank: '',
          agency: '',
          account: '',
          titular: '',
          titularCPF: '',
          account_digit: '',
          digit: ''
        },
      },
      checking_document: false,
      valid_document: false,
    }
  },
  methods: {
    nextStep(step){
      if(this.valid_document){
        if(this.$refs[step].validate()){
          this.stepper ++
        }
      }else{
        this.addNotification({type: 'error', msg: 'Preencha o campo com um CPF válido.'})
      }
    },
    checkIfCpfExists(cpf){
      if(cpf.length == 14){
        this.checkIfDocumentExists(cpf.replace(/[^0-9]/g, ''), 'checkDriverCpf')
      }
    },
    checkIfCnpjExists(cnpj){
      if(cnpj.length == 18){
        this.checkIfDocumentExists(cnpj, 'checkDriverCnpj')
      }
    },
    checkIfDocumentExists(document, action){
      if(!this.checking_document){
        this.checking_document = true
        setTimeout(() => {
          Api.Driver[action]((document)).then(res => res.data).then(data =>{
            if(data.id){ 
              this.$router.push({name:"DriverExist",params:{id: data.id}}) 
              this.valid_document = false
            }else{
              this.valid_document = true
            }
          }).catch((err) => {
            console.log(err)
            this.addNotification({type: 'error',  msg: `Não foi possível validar o CPF, preencha o campo novamente.`})
          }).finally(() => {
            this.checking_document = false
          })
        }, 10);
      }
    },
    buscarCEP() {
      let cep = this.driver.address.cep.replace(/\D/g,'');
      if (/^[0-9]{8}$/.test(cep)) {
        this.$http.get("https://viacep.com.br/ws/" + cep + "/json/")
          .then(response => response.data)
          .then(endereco => {
            if (!endereco.erro) {
              this.driver.address = endereco;
            }
          }).catch(function (error) {
            console.log(error);
          })
      }
    },
    addContato(qtd) {
      if (qtd == 'more') {
        this.contato3 += 1;
        if (this.contato3 > 3) {
          this.contato3 = 1;
        }
      } else {
        this.contato3 -= 1;
        if (this.contato3 < 2) {
          this.contato3 = 1;
          this.driver.contatos.emailSecondary = '';
          this.driver.contatos.phoneSecondary = '';
          this.driver.contatos.mobileSecondary = '';
        }
      }
    },
    genAddress() {
      this.driver.address_attributes.state = this.driver.address.uf;
      this.driver.address_attributes.zip = this.driver.address.cep;
      this.driver.address_attributes.complement = this.driver.address.complemento;
      this.driver.address_attributes.neighborhood = this.driver.address.bairro;
      this.driver.address_attributes.city = this.driver.address.localidade;
      this.driver.address_attributes.addr = this.driver.address.logradouro;
      this.driver.address_attributes.number = this.driver.addressNumber;
    },
    genContacts() {
      this.driver.contacts_attributes = []
      if (this.driver.contatos.mobilePrimary != '') {
        this.driver.contacts_attributes.push({
          'email': this.driver.contatos.emailPrimary,
          'telephone': this.driver.contatos.phonePrimary,
          'celphone': this.driver.contatos.mobilePrimary,
        })
      };
      if (this.contato3 > 1) {
        this.driver.contacts_attributes.push({
          'email': this.driver.contatos.emailSecondary,
          'telephone': this.driver.contatos.phoneSecondary,
          'celphone': this.driver.contatos.mobileSecondary,
        })
      };
    },
    genAccount() {
      let receiptForm = this.$refs.step4?.local_model
      if (receiptForm) {
        this.driver.receipt_config = {...receiptForm.receipt_config}
        this.driver.freight_kind_default = receiptForm.freight_kind_default || null
      }
      let kinds = this.driver.receipt_config.kinds?.length
        ? this.driver.receipt_config.kinds
        : [this.driver.receipt_config.kind]
      this.driver.receipt_config.kinds = kinds
      this.driver.receipt_config.kind = kinds[0]

      this.driver.accounts_attributes = []
      if (kinds.includes('deposit') && receiptForm?.accounts?.[0]?.bank_id) {
        let account = receiptForm.accounts[0]
        this.driver.accounts_attributes.push({
          bank_id: account.bank_id,
          current_account: account.current_account,
          number: account.number,
          account_digit: account.account_digit,
          agency: account.agency,
          digit: account.digit,
          CPF: this.cnpj_account ? 1 : account.CPF,
          name: account.name,
          CNPJ: this.cnpj_account ? account.CNPJ : 1,
        })
      }
      if (!kinds.includes('pix')) {
        this.driver.receipt_config.pix_key_kind = null
        this.driver.receipt_config.pix_key = null
      }
    },
    submitDriver() {
      if(this.$refs.step4.validate()){
        if (this.$refs.step1.validate() && this.$refs.step2.validate() && this.$refs.step3.validate()) {
          this.saving = true
          this.genAddress();
          this.genContacts();
          this.genAccount();
          Api.Driver.create(this.driver).then(response => response.data).then(driver => {
            let id = driver?.id || driver?.data?.id
            if (!id) {
              throw new Error('Resposta sem ID do motorista')
            }
            this.addNotification({type: 'success',  msg: `Motorista 3º cadastrado com sucesso!`})
            this.uploadDriverAttachments(id)
            setTimeout(() => {
              this.saving = false
              this.$router.push({name: 'DriversList'})
            }, 500)
          }).catch((err) => {
            console.log(err)
            this.addNotification({type: 'error',  msg: `Ocorreu um erro, o motorista não pode ser cadastrado!`})
            this.saving = false
          });
        }else{
          this.addNotification({type: 'error',  msg: `Alguns campos não foram preenchidos.`})
        }
      }
    },
    uploadDriverAttachments(id) {
      try {
        this.$refs.attach?.updateFile?.(id)
      } catch (err) {
        console.log(err)
      }
      this.$refs.addressProof?.uploadFiles?.(id)
    },
    ...mapActions({
      getBanks: 'Bank/index',
      addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      allDrivers: state => state.Driver.allDrivers,
      allBanks: state => state.Bank.allBanks
    })
  },
  mounted() {
    this.getBanks();
  },
  watch: {
    'driver.kind'(nv){
      if(this.driver.kind == 'driver'){
        this.driver.cnpj = ''
      }else{
        this.driver.cpf = ''
        this.driver.cnh = ''
      }
    },
    cnpj_account(nv) {
      if (nv) {
        this.driver.accounts.titularCPF = null
      } else {
        this.driver.accounts.titularCNPJ = null
      }
    }
  },
}
</script>

<style scoped>
.camera-modal-container {
  width: 100%;
  align-items: center;
  margin-bottom: 24px;
}

.camera-modal {
  height: 100%;
}

.camera-stream {
  width: 100%;
  max-height: 100%;
}

.sumir {
  display: none;
}
</style>